export const CategoryEnumValue = {
  Wall: 10,
  Ceiling: 20,
  Other: 30,
};

export const CategoryEnum = [
  {
    value: CategoryEnumValue.Wall,
    name: 'Wall',
    labelFrench: 'Mur',
    labelEnglish: 'Wall',
  },
  {
    value: CategoryEnumValue.Ceiling,
    name: 'Ceiling',
    labelFrench: 'Plafond',
    labelEnglish: 'Ceiling',
  },
  {
    value: CategoryEnumValue.Other,
    name: 'Other',
    labelFrench: 'Autre',
    labelEnglish: 'Other',
  },
];

export default CategoryEnum;
